import React from 'react'
import './Councelling.css'
import img from '../Images/PIC.png'
import img1 from '../Images/Default.png'
import img2 from '../Images/Maskgroup.png'

const Councelling = () => {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-lg-12 col-md-12 col-sm-12'>
          <img src={img2} />
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <p className='guidance'>
            Guidance and  Counselling  services are  provided  by
            trained   counsellors  to   all  the   students.  The
            development  of the  child in   all areas of physical,
            psychological,  emotional,   social,   academic   and
            behavioral changes   are looked into  and  cared  for.
            Close monitoring  and  timely guidance  throughout the
            year is provided to all students with the co-operation
            of the teachers and the parents
          </p>
          <h1 className='extra-heading'>Area in which we excell:</h1>
          <div className='d-flex'>
            <div><img className='arow' src={img1} /></div>
            <p className='every'>
              Every child is given enough opportunities to explore his / her talent.</p>
          </div>
          <div className='d-flex mt-2'>
            <div><img className='arow' src={img1} /></div>
            <p className='every'>
              Specialized inclusive support for children with special needs / learning <br /> disability is taken into consideration.
            </p>
          </div>
          <div className='d-flex mt-3'>
            <div><img className='arow' src={img1} /></div>
            <p className='every'>
              The school endeavours towards holistic development and ensures the <br /> all round development of the child
            </p>
          </div>
        </div>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <img src={img} />
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-12 col-md-12 col-sm-12'>
          <p className='last-heading'>
            EXTRA-CURRICULAR ACTIVITIES OF THE SCHOOL LIFE
          </p>
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-12 col-sm-12 col-md-12'>
          <div className='last'>
            <div className='d-flex mt-3'>
              <div><img className='arow1' src={img1} width={'50px'} /></div>
              <p className='every'>
                Now a day’s most of the students are exposed to knowledge explosion in their study methods and extracurricular activities. They are involved in all types of activities such as sports,dance,singing, music, public speaking etc.
              </p>
            </div>

            <div className='d-flex mt-3'>
              <div><img className='arow1' src={img1} width={'50px'} /></div>
              <p className='every'>
                Every student wears a different type of traditional dress. Traditions, customs and colourful festivals of the country are observed. We have Traditional Day, when students from all sections of the school are traditionally dressed up to exhibit our rich culture.
              </p>
            </div>

            <div className='d-flex mt-3'>
              <div><img className='arow2' src={img1} width={'30px'} /></div>
              <p className='every'>
                Our school celebrates Annual day and Annual Sports Day for our students. Students take part in various activities and show their talents
              </p>
            </div>

            <div className='d-flex mt-3'>
              <div><img className='arow' src={img1} width={'25px'} /></div>
              <p className='every'>
                Training in Personality Development of the students is given by the school.
              </p>
            </div>

            <div className='d-flex mt-3'>
              <div><img className='arow3' src={img1} width={'40px'} /></div>
              <p className='every'>
                Environmental Club, Social Service Group, etc., are the part of school which makes school life meaningful. Girl Guides, Boy Scouts, Bulbuls and Cubs are the extended activities of the school.
              </p>
            </div>

            <div className='d-flex mt-3'>
              <div><img className='arow3' src={img1} width={'35px'} /></div>
              <p className='every'>
                There are tournaments, cultural shows, competitions, outings, Field trips, Educational trips etc., which makes the school life lively, interesting and enjoyable.
              </p>
            </div>

            <div className='d-flex mt-3'>
              <div><img className='arow4' src={img1} width={'70px'} /></div>
              <p className='every'>
                The key functions of school are School Annual Sports day, Parents’ Day, Teacher’s Day, Children’s Day, and Annual Day etc. These are celebrated in a grand manner providing lot of opportunities for the development of students’inborn talents and abilities. A huge platform is provided by the school.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Councelling
